// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22PZ5","colBig":"styles_colBig__24sIy","colSmall":"styles_colSmall__TNmyR","shopifyNameWrapper":"styles_shopifyNameWrapper__2b5y2"};